export default __webpack_public_path__ + "static/media/trenza-rubio.9493933b.png";